export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-pan-item/index.js